function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawMakingArt = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 860.92 810.99",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 430.02,
    y1: 841.28,
    x2: 430.02,
    y2: 145.5,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "prefix__c",
    x1: 612.52,
    y1: 436.02,
    x2: 612.52,
    y2: 230.97,
    xlinkHref: "#prefix__a"
  }), React.createElement("radialGradient", {
    id: "prefix__b",
    cx: 626.92,
    cy: 274.41,
    r: 10.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1
  })), React.createElement("radialGradient", {
    id: "prefix__d",
    cx: 1932.92,
    cy: 274.41,
    r: 10.14,
    gradientTransform: "matrix(-1 0 0 1 2529 0)",
    xlinkHref: "#prefix__b"
  })), React.createElement("path", {
    d: "M265.83 29.67c29.21-26 75.07-31.33 116.8-29.26 131.09 6.51 249.42 69.8 351.83 141.39 37.06 25.91 73.54 53.84 97.59 89.53 49 72.64 34.44 173.28-33.64 233.13-23.17 20.36-51.25 36-80.08 49.81-51.26 24.61-106.57 44.36-164.74 50-41.49 4-83.49.75-124.73-4.85-115.29-15.64-228.4-50.2-323.2-109.33-41.59-25.93-80.78-58.17-97.92-100.12s-6.17-95.11 36.29-119.94c17.56-10.27 38.56-14.91 59.11-19.26 30.26-6.41 61-12.73 88.31-25.77 28.2-13.46 61.59-39.49 56-69.28-5.99-31.97-10.79-60.05 18.38-86.05z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M675.05 235.2s-10.58-4.29-44.24 11.14-37.86 13.48-46.57 11.16-13.57-2.92-22.91-15.81c0 0-6.59-35.71-13-41.25s-33.47 3.16-33.47 3.16-32.49 7.45-38.68-36c0 0 4.39-32.72-1.59-42.76 0 0 12.08 5.2 32-3.2s35.87 9.05 35.87 9.05 5 13 4.5 20.76 2.66 10.67 12.16 6.92c0 0 4.67-6.64-1.94-17.62s-11.33-19.15-9.49-27.67 7.15-20.35 24.2-26.26 40.2-7 51.31-11.67 13.85-7.65 13.85-7.65-6.84 6.85 9.27 35.9 5.84 41.65 5.84 41.65-8.57 20.43-46.41 18.77c0 0-36.46 1.33-16.58 16.79 0 0 12.73-2.59 31.76-8.64s32.77 18.92 36.18 36.29 17.94 26.94 17.94 26.94z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M626.04 89.5l.2-.06c1.46 5.54-14.83 27.82-28.76 45.53l-.16-.13c19.64-24.94 29.85-41.05 28.72-45.34z",
    fill: "#444053"
  }), React.createElement("path", {
    d: "M597.6 134.5l.09.22c-11.13 14.14-25.12 31-36.32 43.53a82.247 82.247 0 0 0-3.15 3.72l-.32-.26c1-1.28 2.09-2.54 3.16-3.73 11.19-12.48 25.4-29.33 36.54-43.48z",
    fill: "#444053"
  }), React.createElement("path", {
    d: "M558.17 181.39l.22.38c-20.38 25.45-21.73 65-21.78 65.31l-4.3-5c.05-.32 5.34-35.06 25.86-60.69z",
    fill: "#444053"
  }), React.createElement("path", {
    d: "M651.46 221.4s-24-12.5-42.76-8-60.95-15.9-60.95-15.9-17.9-7.27-21.5-15.56c0 0-12.29-13-13-19.71s-12.66-23.62-20.46-24.27M647.93 233.43s-12.1-8.16-10.69-17.66M629.37 243.96s-17.31-6.28-19-30.92M601.46 250.34s-16.54-13.72-11.05-37.7M567.87 243.64s-11-23.1-1.21-38.13M651.69 206.17s-12.51 4-9.83 10.56M636.59 183.5s-16.75 5.31-17.14 29M613.23 177.98s-15.25 18.82-14.13 35.92M586.53 185.36s-15.14 14.48-13.21 22.53M577.4 180.25s-14.2 2.54-16.19-2.12M558.95 163.11s7.17 9.5 9 7.37M630.07 157.1s-35.8 2.6-43.9-8.2M551.46 115.23s16.79 36.05 29 40.64M569.04 98.06s10.31 33.16 23.09 43.51",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M645.13 129.73s-27.22 11.68-43.56-.14M593.28 90.99s6.22 24.37 14.6 30.26M641.02 102.42s-15.3 5.8-21 1.36",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), React.createElement("path", {
    d: "M545.84 171.07s0 21.25-5.78 22.76M498.55 198.6s23 2 33.57-9.89M539.92 145.97s-5.56 21.55-20.9 27.36M484.77 175.9s16.26 5.65 30.25-8.74M521.83 127.44s-1.53 18.3-11.48 26.87M485.39 148.01s13.49.09 16.65-4.31",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  }), React.createElement("ellipse", {
    cx: 424.48,
    cy: 737.99,
    rx: 376,
    ry: 73,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#504f60",
    d: "M447.06 435.03l-.11 3.89-6.76 238.52h-11.36l5.56-238.52.11-4.49 12.56.6z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M447.06 435.03l-.11 3.89-6.76 238.52h-11.36l5.56-238.52.11-4.49 12.56.6z"
  }), React.createElement("path", {
    fill: "#504f60",
    d: "M512.82 637.09l-8.5-.02-126.44-.27-6.74-.01 3.59-11.06h137.2l.89 11.36z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M447.06 435.03l-.11 3.89h-12.56l.11-4.49 12.56.6z"
  }), React.createElement("path", {
    fill: "#504f60",
    d: "M430.77 429.2h21.07v7.93h-21.07z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M379 625.73l-1.12 11.07-6.74-.01 3.59-11.06H379z"
  }), React.createElement("path", {
    fill: "#504f60",
    d: "M397.14 429.05l-.34 3.44-28.05 276.64-12.85-.61 29.55-276.03.33-3.14 11.36-.3z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M512.82 637.09l-8.5-.02-1.16-11.34h8.77l.89 11.36z"
  }), React.createElement("path", {
    fill: "#504f60",
    d: "M526.27 708.52l-12.86.61-28.04-276.64-.35-3.44 11.36.3.33 3.14 29.56 276.03z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M297.61 156.3h283.36V428H297.61z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M297.61 156.3h283.36V428H297.61z"
  }), React.createElement("path", {
    d: "M444.81 65.44v65.6h-11.05v-65.6a5.53 5.53 0 1 1 11.05 0z",
    fill: "#504f60"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M433.76 125.07h11.06v5.97h-11.06z"
  }), React.createElement("path", {
    d: "M449.15 129.55v21.67h-19.69v-21.67a2.69 2.69 0 0 1 2.69-2.69h14.31a2.7 2.7 0 0 1 2.69 2.69z",
    fill: "#504f60"
  }), React.createElement("circle", {
    cx: 439.29,
    cy: 140.61,
    r: 4.18,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 439.29,
    cy: 139.71,
    r: 4.18,
    fill: "#3f3d56"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M429.43 148.53h19.73v2.69h-19.73zM421.35 152.12h35.87v5.98h-35.87z"
  }), React.createElement("path", {
    fill: "#504f60",
    d: "M421.35 150.32h35.87v5.98h-35.87z"
  }), React.createElement("path", {
    d: "M366.73 421h150.65a6.5 6.5 0 0 1 6.5 6.5v1.42H360.23v-1.42a6.5 6.5 0 0 1 6.5-6.5zM385.78 429.35l11.36-.3-.34 3.44h-11.35l.33-3.14zM430.77 429.2h21.07v3.29h-21.07zM496.71 432.49h-11.34l-.35-3.44 11.36.3.33 3.14z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M366.73 422.77h150.65a6.5 6.5 0 0 1 6.5 6.5v1.42H360.23v-1.42a6.5 6.5 0 0 1 6.5-6.5z",
    fill: "#504f60"
  }), React.createElement("path", {
    d: "M388 184.63c8.78-11.09 22.55-13.34 35.09-12.46 39.38 2.77 74.93 29.72 105.68 60.2 11.13 11 22.09 22.92 29.32 38.12 14.71 30.93 10.34 73.78-10.11 99.26-7 8.67-15.4 15.32-24.06 21.21-15.39 10.48-32 18.88-49.49 21.28-12.46 1.71-25.08.32-37.47-2.06-34.61-6.66-68.59-21.37-97.07-46.55-12.5-11-24.27-24.76-29.42-42.62s-1.85-40.5 10.9-51.07c5.28-4.38 11.59-6.35 17.76-8.21 9.09-2.72 18.33-5.42 26.53-11 8.47-5.74 18.5-16.82 16.82-29.51-1.8-13.57-3.24-25.52 5.52-36.59z",
    fill: primaryColor,
    opacity: 0.05
  }), React.createElement("path", {
    d: "M549 360.73l-81.79 21.7-2.93 9.9a37.37 37.37 0 0 1-10.23-2.56c-1.58-.66-7-4-11.52-5.84a14.6 14.6 0 0 1 1.82-6.78c4.21-7.46 10.27-14.59 10.06-23.09-.07-3-.91-6-1.44-9a88 88 0 0 1-.82-16.32c0-2.86.07-5.71.1-8.56.46.17.93.34 1.43.49.73.23 1.38.45 2 .68v.16a5.82 5.82 0 0 0-.2 1.44c7.58 2.92 7 5.76 7 5.76l.72.15c1.1-5 .56-9-.87-12l-.4-.08a14.2 14.2 0 0 0-7.23-7.16c-.81-.39-1.57-.79-2.28-1.19q.11-9.27.2-18.53a20.76 20.76 0 0 0-.55-6.24 27.39 27.39 0 0 0-3.22-6.06c-1.2-2-2.29-4-3.55-6a26.64 26.64 0 0 1 3.65-3.16c.74-.54 1.5-1.06 2.26-1.58l1.15-.79c1.15-.79 2.29-1.59 3.36-2.45a21.83 21.83 0 0 0 2.94-2.82 15.66 15.66 0 0 0 1.25-1.72l.2-.3a16.71 16.71 0 0 0 1-1.77c.06-.11.1-.22.15-.33a19.9 19.9 0 0 0 .75-1.94 21 21 0 0 0 .55-2.07 1.89 1.89 0 0 1 .05-.23c.14-.7.25-1.41.34-2.12v-.24a35.59 35.59 0 0 0 0-7c-.11-1.18-.25-2.36-.44-3.51-1.19-7.33-3.55-14.6-3-22 0-.31.07-.63.11-.94.5-4.74 2.09-9.44 3.56-14.1.12-.4.25-.79.37-1.19.06-.18.11-.36.17-.54.18-.59.35-1.18.52-1.77v-.08c1.29-4.51 2.14-9 1.46-13.42a19.46 19.46 0 0 0-.64-2.85c-1.95-6.11-7-10.73-12-14.88-8.85-7.38-18.27-14.37-29.07-18.58a50.84 50.84 0 0 0-29.76-2.47c-10.1 2.23-20 1.65-29.9 5.86-3.32 1.42-6.77 3.39-8.08 6.7-.82 2.08-.68 4.37-.86 6.59a22.85 22.85 0 0 1-6.49 14.08c-2.69 2.71-6 4.73-8.66 7.5a18.86 18.86 0 0 0-4.73 9 16.53 16.53 0 0 0-.29 5.05v.05c0 .38.1.75.17 1.12v.14c.07.36.16.71.25 1.06a1.16 1.16 0 0 1 0 .18c.1.34.22.68.35 1l.06.2a12.31 12.31 0 0 0 .53 1.17c1 1.93 2.37 3.63 3.41 5.52.25.46.48.92.68 1.39a24.36 24.36 0 0 1 1.67 5.95c.16 1 .28 2.06.38 3.09.05.52.09 1 .13 1.55a109.39 109.39 0 0 1-.59 21.63c-.22 1.77-.48 3.56-.66 5.34 0 .29-.05.58-.08.87-2.83 1.21-5.26 3.08-6.37 5.85-.93 2.28-.81 4.8-.91 7.24-.12 3.65-.8 7.39-2.91 10.39-2.69 1.23-3.78 3.92-4.25 6.78a40.65 40.65 0 0 0-.53 6.88c0 2.89.08 5.84.31 8.77-.19.35-.37.72-.54 1.1 0 .07 0 .13-.08.19-.14.33-.27.66-.4 1 0 .06-.05.12-.07.19-.15.39-.28.79-.41 1.19-.12.38-.23.77-.33 1.16l-.06.25c-.09.35-.17.69-.25 1v.14c-.08.38-.15.75-.22 1.11a1.7 1.7 0 0 1 0 .22c0 .28-.09.56-.13.82v.26c-.05.32-.08.63-.11.92s0 .47-.06.71a15.68 15.68 0 0 1-.83 4.92 17 17 0 0 1-1.1 2.06c-.13.23-.26.46-.37.69a11.76 11.76 0 0 0-1 3.12 14.87 14.87 0 0 0-.23 1.63c-.1 1.1-.12 2.23-.11 3.35v5.07a34.2 34.2 0 0 1-.48 3.76q-.17.93-.36 1.86c-.13.62-.27 1.24-.41 1.86q-.84 3.84-1.69 7.69c-.57 2.56-1.14 5.12-1.73 7.67-1.18 5.12-2.4 10.22-3.72 15.3a39 39 0 0 0-.87 3.92 13.19 13.19 0 0 0-.09 3.91 7.8 7.8 0 0 0 .76 2.46c.2.4.45.79.68 1.18a9.14 9.14 0 0 1 .63 1.2c.7 1.73.39 3.69.53 5.55a7.34 7.34 0 0 0 .35 1.81 5.84 5.84 0 0 0 5 3.73 4.83 4.83 0 0 0 .85 0l.78 1.85c.8 1.88 1.65 3.84 3.27 5.12a8.69 8.69 0 0 0 7.16 1.28 25.26 25.26 0 0 0 6.85-3c5.17-2.88 10.35-5.77 15.45-8.78a11.15 11.15 0 0 1 2.34 3.49 3.2 3.2 0 0 1 .17 1.16 6.24 6.24 0 0 1-.71 2.24c-1.25 2.66-2.48 5.32-3.71 8-8.61 18.52-6.6 40.09-4.79 60.36.78 8.57 2.1 17.07 2.82 25.64 1.8 21.26 0 42.73 2.44 63.92 1.33 11.42 3.92 22.66 5.68 34a239.56 239.56 0 0 1 2.76 31.3c1-.3 1.95-.56 2.93-.8l1.07-.26c.74-.17 1.48-.31 2.22-.45s1.35-.23 2-.33a68.2 68.2 0 0 1 13.71-.56l1.83.15c.17 1.42.34 2.8.47 4.08 0 .35.07.7.1 1a182.71 182.71 0 0 0 2.4 18.22 14.78 14.78 0 0 1 .36 5c-.46 2.73-2.46 4.94-4.4 7-5.42 5.56-11.19 10.9-15.3 17.45-4.91 7.82-7.18 16.91-9.37 25.83-3.28 13.25-6.53 26.52-8.41 40a7.13 7.13 0 0 0 0 2.48 1.62 1.62 0 0 0-.1.18c-2.26 3.78-5.42 7.1-6.82 11.33a29.08 29.08 0 0 0-1 8.58q-.13 7.5-.28 15c-.21 10.87-.38 21.94 2.88 32.33a26.15 26.15 0 0 0 5.24 9.89 13.8 13.8 0 0 0 10 4.75 17.65 17.65 0 0 0 4.67-.8l.76-.24a13.42 13.42 0 0 0 .34 6.71 4.71 4.71 0 0 0 1.19 2.08 5.3 5.3 0 0 0 1.74 1c9.79 3.8 21 .49 31.33 2.31 12.05 2.11 22.22 11 34.41 12 2.6.22 5.42 0 7.45-1.61a7.67 7.67 0 0 0 2.41-7.35 8.46 8.46 0 0 0-.49-1.61 10.42 10.42 0 0 0-8.24-6.2 38.82 38.82 0 0 1-27.28-17.61c-5-8.07-6.61-17.77-6.31-27.18s2.4-18.68 4.51-27.87q6.34-27.66 12.7-55.31a199.83 199.83 0 0 0 4-21.08c.42-3.62.64-7.27.75-10.93.31-.54.61-1.08.91-1.63 3.6-6.61 7-13.46 8.4-20.82a81.54 81.54 0 0 0 1-11.88v-1c.05-1.36.1-2.73.16-4.09.33 0 .66 0 1-.06 11.56-1.19 21.36-11.06 32.94-10.06 1 .83 1.75-.76 2.34-1.88 5.92-11.15 3.23-24.58.92-36.94a471.23 471.23 0 0 1-7.95-101.34c.44-14.66 1.39-30-1.4-44.2l75.57-25zm-38.82 19c0 1.17-1.51 2.16-3.62 2.54a14.78 14.78 0 0 1 .16-2.67 3.48 3.48 0 0 0-1-2.53c2.54.22 4.48 1.32 4.48 2.64zm-8.18-2.37a3.55 3.55 0 0 0-.76 2.22 3.37 3.37 0 0 1 0 1.63 3.36 3.36 0 0 0 .06.63c-1.29-.5-2.14-1.26-2.14-2.13s1.1-1.88 2.84-2.35zm-158.5-24.78l.13.49h-.93zm28.32 449.19c-1.7-8-1.64-16.33-1.57-24.55q.08-10.15.17-20.31a48.52 48.52 0 0 1 .54-8.26c.26-1.45.65-2.89.94-4.33a52.5 52.5 0 0 1 4.06-8v.1c-.63 11.91-2.84 24.27-.7 35.95a51.16 51.16 0 0 1-3.44 29.4zm83.27-391.1c-.26-.44-.53-.86-.8-1.29 1.52.45 3 .89 4.57 1.32l-1.36 4.61c-.74-1.57-1.5-3.12-2.41-4.64z",
    transform: "translate(-169.54 -44.5)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    d: "M195.17 110.66c-3.24 1.41-6.6 3.38-7.88 6.68-.8 2.06-.66 4.35-.83 6.55a22.94 22.94 0 0 1-6.33 14c-2.62 2.7-5.88 4.72-8.43 7.47-4.64 5-6.53 12.8-3.51 18.92.94 1.92 2.31 3.61 3.32 5.5 1.95 3.62 2.5 7.82 2.78 11.93a111.58 111.58 0 0 1-.56 21.54c-.57 4.57-1.41 9.25-.34 13.73a30 30 0 0 0 4.26 8.94c4.9 7.7 10.59 15.13 18.16 20.24 7.81 5.27 17.23 7.79 26.62 8.53s18.84-.18 28.19-1.31c7-.84 15.18-2.59 18.17-9 1.66-3.59 1.23-7.86 2.79-11.49 2.81-6.55 10.91-9 15.44-14.44 4.72-5.69 4.92-13.87 3.76-21.17s-3.46-14.55-2.92-21.93c.86-11.85 9-23.41 5.42-34.76-1.89-6.09-6.82-10.68-11.68-14.82-8.62-7.35-17.79-14.32-28.32-18.5a48.47 48.47 0 0 0-29-2.47c-9.82 2.25-19.5 1.7-29.11 5.86z",
    fill: "#2f2e41"
  }), React.createElement("g", {
    opacity: 0.08
  }, React.createElement("path", {
    d: "M174.46 186.29a109.46 109.46 0 0 0-.21-11.31c-.28-4.1-.83-8.3-2.78-11.93-1-1.89-2.38-3.57-3.32-5.49a13.86 13.86 0 0 1-1.1-3.19 15.38 15.38 0 0 0 1.1 9.94c.94 1.92 2.31 3.61 3.32 5.5 1.95 3.62 2.5 7.82 2.78 11.93.15 1.51.21 3.03.21 4.55zM287.86 168.62a35.22 35.22 0 0 0 .1 5.81c1.1-10.53 7.48-20.84 5.95-31-1.09 8.28-5.45 16.66-6.05 25.19zM287.02 211.72c-4.53 5.49-12.63 7.89-15.44 14.43-1.56 3.64-1.13 7.91-2.79 11.5-3 6.41-11.14 8.16-18.17 9-9.35 1.13-18.79 2.06-28.19 1.31s-18.81-3.26-26.62-8.53c-7.57-5.11-13.26-12.54-18.16-20.25a30 30 0 0 1-4.26-8.93 15.64 15.64 0 0 1-.31-1.66 25.23 25.23 0 0 0 .31 8.41 30 30 0 0 0 4.26 8.94c4.9 7.7 10.59 15.13 18.16 20.24 7.81 5.27 17.23 7.79 26.62 8.53s18.84-.18 28.19-1.31c7-.84 15.18-2.59 18.17-9 1.66-3.59 1.23-7.86 2.79-11.49 2.81-6.55 10.91-9 15.44-14.44 4-4.8 4.74-11.37 4.19-17.68a19.91 19.91 0 0 1-4.19 10.93z"
  })), React.createElement("path", {
    d: "M265.03 257.75c-3.59 4-9 6.09-14.4 6.36a35.87 35.87 0 0 1-15.68-3.26 57.93 57.93 0 0 1-34.08-45.06 9.49 9.49 0 0 1 .19-4.47c1.45-4.08 6.84-4.74 10.46-7.16 3.3-2.19 5.15-6 6.07-9.89.24-1.05.44-2.1.6-3.17.42-2.85.64-5.74 1.14-8.58a9.11 9.11 0 0 1 1.38-3.85 8.51 8.51 0 0 1 3.63-2.62c8.45-3.67 19.46-2 27.86 1.18 2.81 1.07 2.27 1.39 1.2 4.15a55.4 55.4 0 0 0-1.79 5.37c-.15.51-.29 1-.42 1.54a60 60 0 0 0-1.84 14.37c0 4.44.51 9.09 2.94 12.82 3.87 5.91 11.74 8.4 15.26 14.53a20.58 20.58 0 0 1 2.29 7.86c.85 6.97-.12 14.63-4.81 19.88zM174.52 703.35a29.47 29.47 0 0 0-1 8.54l-.28 15c-.2 10.82-.37 21.85 2.82 32.19a26.08 26.08 0 0 0 5.1 9.86 13.3 13.3 0 0 0 9.76 4.73 16.87 16.87 0 0 0 4.55-.81c2.68-.78 5.48-2 6.93-4.38 1.93-3.18.86-7.22.09-10.86-1.71-8.1-1.65-16.45-1.58-24.73l.17-20.23a49 49 0 0 1 .52-8.22c.39-2.17 1.07-4.3 1.24-6.49a7 7 0 0 0-1.13-4.85 6.73 6.73 0 0 0-3.71-2.17c-2.57-.66-5.27-.49-7.9-.89a11.3 11.3 0 0 1-3.4-1c-.64-.31-2-1.74-2.66-1.73-1.3 0-2.15 3.57-2.87 4.8-2.21 3.71-5.29 7.02-6.65 11.24z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M257.37 564.34c-7.12 21.26-2.28 44.72-4.86 67.08a200 200 0 0 1-3.93 21l-12.37 55.08c-2.05 9.16-4.12 18.38-4.4 27.76s1.32 19 6.16 27.07a37.76 37.76 0 0 0 26.57 17.54 10.19 10.19 0 0 1 8 6.18 8.8 8.8 0 0 1 .47 1.6 7.72 7.72 0 0 1-2.35 7.32c-2 1.6-4.72 1.82-7.25 1.61-11.88-1-21.79-9.88-33.53-12-10.1-1.81-21 1.49-30.52-2.3a5.17 5.17 0 0 1-1.69-1 4.68 4.68 0 0 1-1.16-2.06c-2.24-7 2.36-14.08 5.4-20.76a51.92 51.92 0 0 0 3.84-30.48c-2.08-11.64.07-23.94.69-35.8a216.62 216.62 0 0 1 4.48-32.68c1.5-7.19 2.77-14.54 5.69-21.29 1.75-4 4.06-7.81 5.9-11.8 3.4-7.37 5.14-15.38 6.82-23.32 3.38-16 6.66-32.13 6.66-48.47a50.11 50.11 0 0 1 18.39 3.45 5.15 5.15 0 0 1 2.99 6.27z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M257.37 564.34c-7.12 21.26-2.28 44.72-4.86 67.08a200 200 0 0 1-3.93 21l-12.37 55.08c-2.05 9.16-4.12 18.38-4.4 27.76s1.32 19 6.16 27.07a37.76 37.76 0 0 0 26.57 17.54 10.19 10.19 0 0 1 8 6.18 8.8 8.8 0 0 1 .47 1.6 7.72 7.72 0 0 1-2.35 7.32c-2 1.6-4.72 1.82-7.25 1.61-11.88-1-21.79-9.88-33.53-12-10.1-1.81-21 1.49-30.52-2.3a5.17 5.17 0 0 1-1.69-1 4.68 4.68 0 0 1-1.16-2.06c-2.24-7 2.36-14.08 5.4-20.76a51.92 51.92 0 0 0 3.84-30.48c-2.08-11.64.07-23.94.69-35.8a216.62 216.62 0 0 1 4.48-32.68c1.5-7.19 2.77-14.54 5.69-21.29 1.75-4 4.06-7.81 5.9-11.8 3.4-7.37 5.14-15.38 6.82-23.32 3.38-16 6.66-32.13 6.66-48.47a50.11 50.11 0 0 1 18.39 3.45 5.15 5.15 0 0 1 2.99 6.27z",
    opacity: 0.08
  }), React.createElement("path", {
    d: "M264.52 554.3q-.6 15.5-1.15 31v1a82.12 82.12 0 0 1-1 11.83c-1.35 7.34-4.67 14.16-8.18 20.75a46.53 46.53 0 0 1-3.59 6c-1.18 1.6-2.55 3.06-3.65 4.7-2.85 4.26-3.73 9.48-5.4 14.32-7.63 22.08-31.44 35.4-39.42 57.34a126.44 126.44 0 0 1-17.68-6.39 4.15 4.15 0 0 1-3.09-5.43c1.82-13.43 5-26.65 8.18-39.85 2.13-8.89 4.35-17.93 9.13-25.73 4-6.52 9.63-11.84 14.91-17.38 1.89-2 3.84-4.2 4.28-6.91a14.62 14.62 0 0 0-.35-5q-1.62-9-2.34-18.15c0-.34 0-.69-.09-1-.45-4.59-1.54-10.56-.54-14.85 1.81-7.8 17-9.4 23.65-9.56 8.81-.25 17.62 1.51 26.33 3.31zM282.57 346.94c10.09 4.29 21.65 3.06 32.36.65s21.31-5.91 32.28-6c3.07 0 6.93.91 7.46 3.94.28 1.58-.55 3.13-1.35 4.53-1.47 2.59-3.05 5.29-5.58 6.85-2 1.21-4.3 1.61-6.52 2.24-4.15 1.18-8 3.24-12 4.82-6.79 2.68-14 4-21.23 5.26a40.51 40.51 0 0 1-10.22.93 37.13 37.13 0 0 1-6.76-1.35q-9.75-2.64-19.28-6c-1.26-.45-2.66-1-3.16-2.28a5.29 5.29 0 0 1-.15-2.38 29.09 29.09 0 0 0-.84-9.57c-.41-1.56-3.62-7.13-2.54-8.26 2.49-2.63 15.01 5.55 17.53 6.62z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M282.57 346.94c10.09 4.29 21.65 3.06 32.36.65s21.31-5.91 32.28-6c3.07 0 6.93.91 7.46 3.94.28 1.58-.55 3.13-1.35 4.53-1.47 2.59-3.05 5.29-5.58 6.85-2 1.21-4.3 1.61-6.52 2.24-4.15 1.18-8 3.24-12 4.82-6.79 2.68-14 4-21.23 5.26a40.51 40.51 0 0 1-10.22.93 37.13 37.13 0 0 1-6.76-1.35q-9.75-2.64-19.28-6c-1.26-.45-2.66-1-3.16-2.28a5.29 5.29 0 0 1-.15-2.38 29.09 29.09 0 0 0-.84-9.57c-.41-1.56-3.62-7.13-2.54-8.26 2.49-2.63 15.01 5.55 17.53 6.62z",
    opacity: 0.08
  }), React.createElement("path", {
    d: "M253.4 181.38a55.4 55.4 0 0 0-1.79 5.37 33.12 33.12 0 0 1-33.42 4.35c.42-2.85.64-5.74 1.14-8.58a9.11 9.11 0 0 1 1.38-3.85 8.51 8.51 0 0 1 3.63-2.62c8.45-3.67 19.46-2 27.86 1.18 2.81 1.07 2.26 1.39 1.2 4.15z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 231.24,
    cy: 159.33,
    r: 33.09,
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M264.52 554.3q-.6 15.5-1.15 31c-5.31.3-10.59-1.25-15.69-2.77-10.62-3.14-21.69-6.23-32.66-7.15-.45-4.59-1.54-10.56-.54-14.85 1.81-7.8 17-9.4 23.65-9.56 8.87-.23 17.68 1.53 26.39 3.33z",
    opacity: 0.08
  }), React.createElement("path", {
    d: "M298.86 569.27c-.58 1.12-1.34 2.7-2.28 1.88-11.28-1-20.83 8.83-32.09 10-5.69.59-11.35-1.07-16.81-2.69-18.36-5.44-38.06-10.71-56.29-4.93a244.57 244.57 0 0 0-2.69-31.17c-1.72-11.31-4.24-22.51-5.54-33.88-2.42-21.11-.62-42.49-2.38-63.66-.7-8.54-2-17-2.74-25.54-1.77-20.19-3.73-41.68 4.66-60.13q1.8-4 3.62-7.95a6.22 6.22 0 0 0 .69-2.23 3.39 3.39 0 0 0-.16-1.16c-.49-1.68-2.11-3-3.08-4.58-1.64-2.58-1.46-5.88-1.23-8.93.11-1.29.45-2.35.54-3.64-3.51-4.87-5.56-10.43-7.1-16.25-1.77-6.6-2.89-13.52-4.85-20.06-3.15-10.5-8.54-20.27-11.18-30.91-1.36-5.47-1.46-11.36-1.53-17a42.65 42.65 0 0 1 .51-6.86c.46-2.85 1.53-5.52 4.15-6.75 2.05-3 2.71-6.71 2.83-10.35.1-2.43 0-4.94.88-7.21 1.79-4.52 7-6.66 11.78-7.37s9.87-.54 14.29-2.57a30.33 30.33 0 0 0 4.74-2.89 168.64 168.64 0 0 0 16.35-12.38 1 1 0 0 1 .45-.26c.23 0 .43.15.61.3 4.16 3.7 8.3 7.4 12.46 11.09 2.27 2 4.54 4 6.63 6.23a54.1 54.1 0 0 1 7.71 10.35 48.62 48.62 0 0 1 2.72 5.27 55.53 55.53 0 0 1 3.05 8.65c.42 1.57.76 3.15 1 4.74.19 1.15.35 2.31.46 3.49q.08.58.12 1.17a5 5 0 0 0 1.93-.85 3.92 3.92 0 0 0 1.37-1.74 8.82 8.82 0 0 0 .53-2 20.72 20.72 0 0 0 .2-2.62c0-1 .07-2.09.07-3.13a28.22 28.22 0 0 0-.51-5.43c-.67-3.28-2.12-6.35-3-9.58s-1.16-6.86.48-9.79c.62-1.11 1.77-2.19 3-1.93a3.23 3.23 0 0 1 2 2 10.22 10.22 0 0 1 .84 4.19c0 .7 0 1.27.64 1.62.15 3.28 2.68 6 5.42 7.77s5.86 3.06 8.31 5.25c3.12 2.76 4.84 6.7 7 10.26a27.73 27.73 0 0 1 3.13 6 21.22 21.22 0 0 1 .54 6.21q-.19 19.37-.42 38.72a89.09 89.09 0 0 0 .8 16.26c.51 3 1.34 5.93 1.4 9 .21 8.46-5.7 15.57-9.8 23-3 5.37-1.89 12.16.74 17.73s6.63 10.33 9.7 15.65c10.87 18.84 9.09 42 8.45 63.79a480.35 480.35 0 0 0 7.77 101.03c2.26 12.29 4.88 25.67-.89 36.77z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M248.61 236.5c-1.1 0-2.18.11-3.27.23v3c1.22 0 2.47.11 3.7.26.68.08 1.37.17 2.05.32a15 15 0 0 1 6 2.45c3.36 2.39 5.34 7.13 3.43 10.77l-1.25.52a6.65 6.65 0 0 1 .15 4.22c-.59 1.31-2.54 2.07-3.5 1-1.08-1.23-.11-3.7-1.56-4.46a2 2 0 0 0-2.53 1 5.18 5.18 0 0 0-.27 3c1 7.91 4.78 15.38 4.92 23.36.05 2.57.1 5.61-1.7 7.43q-5.17 5.28-10.38 10.57c-6.46 6.58-12.93 13.17-19.75 19.37a245.22 245.22 0 0 1-34 25.93c-1.27.81-2.55 1.59-3.83 2.38-.49-1.68-2.11-3-3.08-4.58-1.64-2.58-1.46-5.88-1.23-8.93.11-1.29.45-2.35.54-3.64-3.51-4.87-5.56-10.43-7.1-16.25h1.35c4.82-.07 9.44-1.81 13.93-3.53a100.78 100.78 0 0 0 11.81-5.05 86.49 86.49 0 0 0 16-11.56c3.07-2.66 6.74-5.2 10.79-5.44 2.42-2.49 6.16-3.89 7.41-7.13a11.13 11.13 0 0 0 .17-5.59 107.42 107.42 0 0 0-2.81-13c-1-3.35-.73-6.65-1.36-10.08a48.42 48.42 0 0 1-1.16-11.49c.44-7.23 4.09-13.8 7.65-20.1.71-1.21 1.4-2.44 2.08-3.67.57-1 1.15-2 1.72-3a3.07 3.07 0 0 1 2.47 2.91 9 9 0 0 1-.92 4c-.19.46-.36.92-.55 1.38-1.62 4.07-3.26 8.14-4.88 12.22a51.62 51.62 0 0 1 7.93-3.57 22.05 22.05 0 0 1 3.53-.81 14.21 14.21 0 0 1 2.17-.13c3.43 0 6.89 1.21 9 3.89.8 1 1.34 2.55.49 3.51a46.56 46.56 0 0 0-9.75-1.65c-1.47-.12-2.94-.15-4.41-.06z",
    opacity: 0.08
  }), React.createElement("path", {
    d: "M295.39 339.63l-14.86 51.32 83.74-28.36 10.8-44.57zm36.46 0c-3 0-5.4-1.21-5.4-2.7s2.42-2.7 5.4-2.7 5.41 1.21 5.41 2.7-2.42 2.7-5.41 2.7z",
    fill: "#464353"
  }), React.createElement("ellipse", {
    cx: 234.62,
    cy: 139.07,
    rx: 35.79,
    ry: 17.56,
    fill: "#2f2e41"
  }), React.createElement("ellipse", {
    cx: 307.54,
    cy: 349.76,
    rx: 4.73,
    ry: 1.35,
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 302.14,
    cy: 356.51,
    rx: 4.73,
    ry: 1.35,
    fill: "#fbbebe",
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 337.26,
    cy: 347.05,
    rx: 4.73,
    ry: 1.35,
    fill: "#fbbebe",
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 306.19,
    cy: 356.51,
    rx: 4.73,
    ry: 1.35,
    fill: "#fbbebe",
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 298.09,
    cy: 355.16,
    rx: 4.73,
    ry: 1.35,
    fill: "#fbbebe",
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 298.09,
    cy: 359.21,
    rx: 4.73,
    ry: 1.35,
    fill: "#fbbebe",
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 308.89,
    cy: 353.81,
    rx: 4.73,
    ry: 1.35,
    fill: "#fbbebe",
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 300.79,
    cy: 351.11,
    rx: 4.73,
    ry: 1.35,
    fill: "#fbbebe",
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 310.25,
    cy: 355.16,
    rx: 4.73,
    ry: 1.35,
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 312.95,
    cy: 348.4,
    rx: 4.73,
    ry: 1.35,
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 312.95,
    cy: 351.11,
    rx: 4.73,
    ry: 1.35,
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 314.3,
    cy: 355.16,
    rx: 4.73,
    ry: 1.35,
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 327.8,
    cy: 349.76,
    rx: 4.73,
    ry: 1.35,
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 333.2,
    cy: 348.4,
    rx: 4.73,
    ry: 1.35,
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 333.2,
    cy: 351.11,
    rx: 4.73,
    ry: 1.35,
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 326.45,
    cy: 355.16,
    rx: 4.73,
    ry: 1.35,
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 327.8,
    cy: 355.16,
    rx: 4.73,
    ry: 1.35,
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 326.45,
    cy: 355.16,
    rx: 4.73,
    ry: 1.35,
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 322.4,
    cy: 355.16,
    rx: 4.73,
    ry: 1.35,
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 317,
    cy: 349.76,
    rx: 4.73,
    ry: 1.35,
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 318.35,
    cy: 352.46,
    rx: 4.73,
    ry: 1.35,
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 322.4,
    cy: 348.4,
    rx: 4.73,
    ry: 1.35,
    fill: "#3f3d56",
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 322.4,
    cy: 351.11,
    rx: 4.73,
    ry: 1.35,
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 321.05,
    cy: 352.46,
    rx: 4.73,
    ry: 1.35,
    fill: "#f86d70"
  }), React.createElement("ellipse", {
    cx: 326.45,
    cy: 352.46,
    rx: 4.73,
    ry: 1.35,
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 329.15,
    cy: 357.86,
    rx: 4.73,
    ry: 1.35,
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 331.85,
    cy: 351.11,
    rx: 4.73,
    ry: 1.35,
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 331.85,
    cy: 353.81,
    rx: 4.73,
    ry: 1.35,
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 333.2,
    cy: 357.86,
    rx: 4.73,
    ry: 1.35,
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 346.71,
    cy: 352.46,
    rx: 4.73,
    ry: 1.35,
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 352.11,
    cy: 351.11,
    rx: 4.73,
    ry: 1.35,
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 352.11,
    cy: 353.81,
    rx: 4.73,
    ry: 1.35,
    fill: "#a1616a",
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 345.36,
    cy: 357.86,
    rx: 4.73,
    ry: 1.35,
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 346.71,
    cy: 357.86,
    rx: 4.73,
    ry: 1.35,
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 345.36,
    cy: 357.86,
    rx: 4.73,
    ry: 1.35,
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 341.31,
    cy: 357.86,
    rx: 4.73,
    ry: 1.35,
    fill: "#f86d70"
  }), React.createElement("ellipse", {
    cx: 335.91,
    cy: 352.46,
    rx: 4.73,
    ry: 1.35,
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 337.26,
    cy: 355.16,
    rx: 4.73,
    ry: 1.35,
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 341.31,
    cy: 351.11,
    rx: 4.73,
    ry: 1.35,
    fill: "#a1616a",
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 341.31,
    cy: 353.81,
    rx: 4.73,
    ry: 1.35,
    fill: "#f86d70"
  }), React.createElement("ellipse", {
    cx: 339.96,
    cy: 355.16,
    rx: 4.73,
    ry: 1.35,
    fill: "#f86d70"
  }), React.createElement("ellipse", {
    cx: 463.34,
    cy: 409.23,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 139.487 1298.254)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 466.99,
    cy: 414.04,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 143.156 1303.095)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 468.4,
    cy: 406.91,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 144.579 1295.963)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 468.9,
    cy: 409.56,
    rx: 4.73,
    ry: 1.35,
    transform: "matrix(.98 -.18 .18 .98 -237.06 49.04)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 470.97,
    cy: 413.3,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 147.13 1302.326)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 483.25,
    cy: 405.49,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 159.404 1294.523)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 488.31,
    cy: 403.17,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 164.5 1292.179)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 488.81,
    cy: 405.83,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 164.954 1294.877)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 482.92,
    cy: 411.05,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 159.104 1300.08)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 484.24,
    cy: 410.8,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 160.429 1299.823)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 482.92,
    cy: 411.05,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 159.104 1300.08)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 478.94,
    cy: 411.8,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 155.075 1300.843)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 472.63,
    cy: 407.49,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 148.81 1296.52)",
    fill: "#3f3d56",
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 474.46,
    cy: 409.89,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 150.593 1298.908)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 477.69,
    cy: 405.16,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 153.853 1294.17)",
    fill: "#3f3d56",
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 478.19,
    cy: 407.82,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 154.36 1296.873)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 477.11,
    cy: 409.4,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 153.297 1298.4)",
    fill: "#3f3d56",
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 482.42,
    cy: 408.4,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 158.591 1297.43)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 486.07,
    cy: 413.21,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 162.212 1302.212)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 487.48,
    cy: 406.07,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 163.635 1295.08)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 487.98,
    cy: 408.73,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 164.142 1297.783)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 490.05,
    cy: 412.46,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 166.236 1301.502)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 502.33,
    cy: 404.66,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 178.508 1293.699)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 507.39,
    cy: 402.34,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 183.552 1291.349)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 507.89,
    cy: 404.99,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 184.064 1293.999)",
    fill: "#a1616a",
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 502,
    cy: 410.22,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 178.155 1299.25)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 503.33,
    cy: 409.97,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 179.48 1298.993)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 502,
    cy: 410.22,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 178.155 1299.25)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 498.02,
    cy: 410.97,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 174.18 1300.018)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 491.71,
    cy: 406.65,
    rx: 4.73,
    ry: 1.35,
    transform: "matrix(.98 -.18 .18 .98 -236.13 53.2)",
    fill: "#a1616a",
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 493.54,
    cy: 409.06,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 169.698 1298.083)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("path", {
    d: "M215.53 181.75l-1 1s45.39 71 55.44 78.55l3.09-2.5s-11.6-21.3-57.53-77.05z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M275.72 261.41s-2.39-4.32-3.31-3.46-3.88 2.86-3.49 3.49 3 4.09 3 4.09 3.42-.1 4.47-3.08z",
    fill: "#464353"
  }), React.createElement("path", {
    d: "M290.85 284.07l-.51-.12s.4-2.31-5.07-4.69a30.89 30.89 0 0 0-3.06-1.13c-8.4-2.65-11.68-8.47-10-12.63a3.47 3.47 0 0 1 .16-.41l3.5-2.75.41.35a35.24 35.24 0 0 0 6.9 4.39 14 14 0 0 1 7.06 7.18 16.9 16.9 0 0 1 .61 9.81z",
    fill: "#fdd8d8",
    opacity: 0.9
  }), React.createElement("path", {
    d: "M275.6 263.08s1.19 2.6 7.45 5.67 7.59 12 7.59 12-3.26-8.27-8.27-9.79-7.23-7.41-7.23-7.41z",
    fill: "none",
    stroke: "#2f2e41",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    opacity: 0.2
  }), React.createElement("path", {
    d: "M274.65 264.11s-.28 3.51 3.82 6.62 11.89 8.13 12.06 10.49c0 0-3.75-3.91-7-5.21s-7.68-3.93-8.18-6.37c0 0-1.8-3.82-1.27-5.31z",
    fill: "none",
    stroke: "#2f2e41",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    opacity: 0.2
  }), React.createElement("path", {
    d: "M273.39 264.89s-1.68 3.37 2.42 8.08a17.55 17.55 0 0 0 6.95 3.94 16.9 16.9 0 0 1 7.4 5.12",
    fill: "none",
    stroke: "#2f2e41",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    opacity: 0.2
  }), React.createElement("ellipse", {
    cx: 496.77,
    cy: 404.33,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 172.958 1293.345)",
    fill: "#3f3d56",
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 497.27,
    cy: 406.98,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 173.416 1295.99)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("ellipse", {
    cx: 496.19,
    cy: 408.56,
    rx: 4.73,
    ry: 1.35,
    transform: "rotate(-10.63 172.348 1297.57)",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("path", {
    d: "M156.09 264.75a19.85 19.85 0 0 1-.86 5.61c-.39.95-1 1.81-1.44 2.74-1.95 4-1.09 8.69-1.36 13.12a51.19 51.19 0 0 1-1.22 7.45c-2.19 10.2-4.38 20.41-7 30.53-.86 3.39-1.73 7.12-.19 10.25.4.81.94 1.54 1.27 2.38.92 2.3.07 5 .87 7.33a5.64 5.64 0 0 0 5.81 3.69c.56-9.57 5.05-18.51 10.52-26.39 2.6-3.74 5.51-7.39 9.36-9.82 1.89-1.19 4-2.1 5.52-3.75a12.88 12.88 0 0 0 2.76-6.59c2.64-14.78-3.69-29.64-11-42.77-1.52-2.73-4.74-8.8-7.95-6.51s-4.72 9.05-5.09 12.73z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M234.62 151.23c-17.9 0-32.72-6.44-35.37-14.85a8.85 8.85 0 0 0-.42 2.7c0 9.69 16 17.55 35.79 17.55s35.78-7.86 35.78-17.55a8.85 8.85 0 0 0-.42-2.7c-2.65 8.41-17.47 14.85-35.36 14.85z",
    opacity: 0.1
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M153.46 336.83c-.34-.84-.88-1.57-1.28-2.38-1.54-3.13-.67-6.86.2-10.25 2.57-10.12 4.76-20.33 7-30.53a49.85 49.85 0 0 0 1.21-7.45c.27-4.43-.58-9.14 1.36-13.12.46-.93 1.05-1.79 1.44-2.74a19.5 19.5 0 0 0 .86-5.61 28.37 28.37 0 0 1 2.63-9.54c-.22-2.92-.26-5.86-.3-8.74a41.54 41.54 0 0 1 .52-6.86c.45-2.85 1.52-5.52 4.14-6.75 2-3 2.72-6.71 2.84-10.35.09-2.43 0-4.94.88-7.21 1.78-4.52 7-6.66 11.77-7.37s9.87-.54 14.29-2.57a30.33 30.33 0 0 0 4.74-2.89c4.31-3 8.63-6 12.71-9.31l-3.4-3c-.18-.15-.38-.33-.61-.3a1 1 0 0 0-.45.26 168.64 168.64 0 0 1-16.41 12.38 30.33 30.33 0 0 1-4.74 2.89c-4.42 2-9.48 1.85-14.29 2.57s-10 2.85-11.78 7.37c-.9 2.27-.78 4.78-.88 7.21-.12 3.64-.78 7.36-2.83 10.35-2.62 1.23-3.69 3.9-4.15 6.75a42.65 42.65 0 0 0-.47 6.86c0 2.88.08 5.82.3 8.74a28.14 28.14 0 0 0-2.63 9.54 19.85 19.85 0 0 1-.86 5.61c-.39.95-1 1.81-1.44 2.74-1.95 4-1.09 8.69-1.36 13.12a51.19 51.19 0 0 1-1.22 7.45c-2.19 10.2-4.38 20.41-7 30.53-.86 3.39-1.73 7.12-.19 10.25.4.81.94 1.54 1.27 2.38.92 2.3.07 5 .87 7.33a5.64 5.64 0 0 0 5.81 3.69 38.82 38.82 0 0 1 1.8-9.44 6.16 6.16 0 0 0-.35-1.61zM251.19 220.1c.51 1 1 2 1.44 3a54.51 54.51 0 0 1 3.05 8.65c.42 1.57.76 3.15 1 4.74.19 1.15.35 2.31.46 3.49q.07.58.12 1.17a5 5 0 0 0 1.93-.85 3.93 3.93 0 0 0 1.37-1.77 9.37 9.37 0 0 0 .52-2 20.72 20.72 0 0 0 .21-2.62c0-1 .06-2.09.06-3.13a28.22 28.22 0 0 0-.51-5.43c-.66-3.28-2.12-6.35-3-9.58-.07-.23-.12-.48-.18-.72a7.47 7.47 0 0 1-.92-3.14c-.62-.35-.66-.92-.64-1.62a10.22 10.22 0 0 0-.84-4.19 3.23 3.23 0 0 0-2-2c-1.25-.26-2.4.82-3 1.93-1.64 2.93-1.37 6.57-.48 9.79.38 1.42.9 2.85 1.41 4.28zM196.8 542.38c-1.71-11.31-4.24-22.51-5.54-33.88-2.41-21.11-.62-42.49-2.37-63.66-.71-8.54-2-17-2.74-25.54-1.77-20.19-3.73-41.68 4.65-60.13 1.21-2.66 2.41-5.31 3.62-7.95a6.22 6.22 0 0 0 .69-2.23 3.17 3.17 0 0 0-.16-1.16c-.49-1.68-2.11-3-3.08-4.58-1.63-2.58-1.46-5.88-1.23-8.93.11-1.29.45-2.35.54-3.64-3.51-4.87-5.56-10.43-7.1-16.25-.4-1.5-.77-3-1.12-4.53-1 .6-2 1.13-3 1.74a23.26 23.26 0 0 0-3.91 3.15 47.63 47.63 0 0 0 7 15.89c-.09 1.29-.43 2.35-.54 3.64-.23 3.05-.41 6.35 1.23 8.93 1 1.57 2.59 2.9 3.08 4.58a3.39 3.39 0 0 1 .16 1.16 6.22 6.22 0 0 1-.69 2.23q-1.82 4-3.62 7.95c-8.39 18.45-6.43 39.94-4.66 60.13.76 8.53 2 17 2.74 25.54 1.76 21.17 0 42.55 2.38 63.66 1.3 11.37 3.82 22.57 5.54 33.88a244.57 244.57 0 0 1 2.69 31.17 52.35 52.35 0 0 1 8-1.83 242.43 242.43 0 0 0-2.56-29.34zM255.78 578.5c-14-4.14-28.71-8.16-43-7.31 11.7.66 23.56 4 34.9 7.31 5.46 1.62 11.12 3.28 16.81 2.69.47 0 .94-.14 1.41-.21a73.59 73.59 0 0 1-10.12-2.48z"
  })), React.createElement("path", {
    d: "M148.28 339.05l4.4 10.64c.78 1.87 1.61 3.83 3.19 5.1a8.27 8.27 0 0 0 7 1.28 24.58 24.58 0 0 0 6.67-3c6.67-3.79 13.34-7.59 19.83-11.7a247.3 247.3 0 0 0 34-25.93c6.82-6.2 13.29-12.79 19.75-19.37l10.34-10.57c1.8-1.82 1.74-4.87 1.7-7.43-.14-8-4-15.44-4.93-23.36a5.26 5.26 0 0 1 .27-3 2 2 0 0 1 2.54-1c1.45.75.48 3.23 1.56 4.46 1 1.07 2.91.33 3.49-1a6.51 6.51 0 0 0-.14-4.22l1.25-.52c1.91-3.64-.07-8.39-3.43-10.78s-7.66-2.92-11.78-3v-3a46.18 46.18 0 0 1 17.47 1.48c.86-1 .31-2.5-.49-3.51-2.55-3.23-7.09-4.32-11.16-3.76s-7.82 2.48-11.46 4.38l5.43-13.61a8.93 8.93 0 0 0 .91-4 3.06 3.06 0 0 0-2.46-2.91l-3.8 6.71c-3.56 6.29-7.21 12.87-7.65 20.08a47.49 47.49 0 0 0 1.16 11.5c.63 3.43.41 6.72 1.36 10.08a105 105 0 0 1 2.81 13 11 11 0 0 1-.18 5.59c-1.24 3.24-5 4.65-7.4 7.14-4 .24-7.72 2.78-10.79 5.44a86.49 86.49 0 0 1-16 11.56 104.28 104.28 0 0 1-11.81 5.05c-4.5 1.72-9.12 3.45-13.93 3.53-3.59 0-7.29-.81-10.71.27-5.15 1.61-8 7-10.3 11.84l-3.81 8a58.92 58.92 0 0 0-2.9 8.54z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M162.19 320.84c2.67-3.83 5.67-7.56 9.63-10 .74-.46 1.5-.88 2.25-1.31-3.07-.15-6.16-.58-9.07.32-5.29 1.66-8.22 7.14-10.6 12.13l-3.94 8.17a60.23 60.23 0 0 0-3 8.7l3.75 9h.09c.62-9.8 5.25-18.94 10.89-27.01z",
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 331.18,
    cy: 336.79,
    rx: 2.7,
    ry: 3.24,
    fill: "#fbbebe"
  }), React.createElement("ellipse", {
    cx: 331.18,
    cy: 338.41,
    rx: 2.7,
    ry: 3.24,
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M291.46 286.28l-.69-.14s.54-2.83-6.84-5.73a6.18 6.18 0 0 1 .2-1.44 5.21 5.21 0 0 1 .35-1.12 5.09 5.09 0 0 1 .53-1 5.52 5.52 0 0 1 1.67-1.82 4.78 4.78 0 0 1 1.5-.7 4.29 4.29 0 0 1 1.2-.16 5.69 5.69 0 0 1 1.24.16c1.37 3.04 1.9 6.97.84 11.95z",
    fill: primaryColor,
    opacity: 0.9
  }), React.createElement("path", {
    d: "M121.46 660.5s6.22 8.13-2.87 20.41-16.58 22.64-13.55 30.3c0 0 13.71-22.8 24.87-23.12s3.8-13.87-8.45-27.59z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M121.46 660.5a10 10 0 0 1 1.27 2.55c10.89 12.8 16.69 24.74 6.23 25-9.75.27-21.45 17.71-24.25 22.11a9.16 9.16 0 0 0 .33 1s13.71-22.8 24.87-23.12 3.8-13.82-8.45-27.54z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M132.99 670.88c0 2.86-.32 5.18-.72 5.18s-.71-2.32-.71-5.18.4-1.52.79-1.52.64-1.35.64 1.52z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M136.96 674.29c-2.51 1.37-4.71 2.2-4.89 1.85s1.69-1.74 4.2-3.11 1.52-.37 1.71 0 1.48-.11-1.02 1.26z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M88.59 660.5s-6.22 8.13 2.87 20.41 16.58 22.64 13.55 30.3c0 0-13.71-22.8-24.87-23.12s-3.83-13.87 8.45-27.59z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M88.59 660.5a10 10 0 0 0-1.27 2.55c-10.89 12.8-16.69 24.74-6.23 25 9.75.27 21.45 17.71 24.25 22.11a9.16 9.16 0 0 1-.33 1s-13.71-22.8-24.87-23.12-3.83-13.82 8.45-27.54z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M77.03 670.88c0 2.86.32 5.18.72 5.18s.71-2.32.71-5.18-.4-1.52-.79-1.52-.64-1.35-.64 1.52z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M73.06 674.29c2.51 1.37 4.7 2.2 4.89 1.85s-1.69-1.74-4.2-3.11-1.52-.37-1.71 0-1.49-.11 1.02 1.26z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M79.01 710.15s17.38-.53 22.62-4.27 26.75-8.18 28.05-2.2 26.12 29.76 6.49 29.92-45.6-3.06-50.83-6.24-6.33-17.21-6.33-17.21z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M136.52 731.5c-19.62.16-45.6-3.06-50.83-6.24-4-2.43-5.57-11.14-6.1-15.15h-.58s1.1 14 6.33 17.21 31.21 6.4 50.83 6.24c5.67 0 7.63-2.06 7.52-5.05-.79 1.85-2.95 2.99-7.17 2.99z",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M566 689.69s-11.11-37.73 2.08-65.5a59.59 59.59 0 0 0 4.82-37.39 100.34 100.34 0 0 0-5.29-17.55",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M575.82 551.7c0 4.63-8.37 18-8.37 18s-8.38-13.41-8.38-18a8.38 8.38 0 0 1 16.75 0zM589.66 577.32c-2.51 3.88-16.83 10.58-16.83 10.58s.26-15.8 2.77-19.68a8.374 8.374 0 0 1 14.06 9.1zM589.05 621.09c-4.12 2.08-19.87.64-19.87.64s8.21-13.51 12.33-15.6a8.394 8.394 0 1 1 7.54 15zM581.14 654.1c-3.72 2.75-19.48 4-19.48 4s5.8-14.7 9.52-17.45a8.384 8.384 0 1 1 10 13.46zM555.25 588.8c3.32 3.22 18.77 6.56 18.77 6.56s-3.79-15.35-7.1-18.57a8.37 8.37 0 1 0-11.67 12zM546.46 627.5c4.13 2.08 19.87.64 19.87.64s-8.2-13.51-12.33-15.6a8.38 8.38 0 0 0-7.54 14.96zM543.13 666.34c3.71 2.75 19.47 4 19.47 4s-5.8-14.71-9.52-17.46a8.388 8.388 0 0 0-10 13.47z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M575.82 551.7c0 4.63-8.37 18-8.37 18s-8.38-13.41-8.38-18a8.38 8.38 0 0 1 16.75 0zM589.66 577.32c-2.51 3.88-16.83 10.58-16.83 10.58s.26-15.8 2.77-19.68a8.374 8.374 0 0 1 14.06 9.1zM589.05 621.09c-4.12 2.08-19.87.64-19.87.64s8.21-13.51 12.33-15.6a8.394 8.394 0 1 1 7.54 15zM581.14 654.1c-3.72 2.75-19.48 4-19.48 4s5.8-14.7 9.52-17.45a8.384 8.384 0 1 1 10 13.46zM555.25 588.8c3.32 3.22 18.77 6.56 18.77 6.56s-3.79-15.35-7.1-18.57a8.37 8.37 0 1 0-11.67 12zM546.46 627.5c4.13 2.08 19.87.64 19.87.64s-8.2-13.51-12.33-15.6a8.38 8.38 0 0 0-7.54 14.96zM543.13 666.34c3.71 2.75 19.47 4 19.47 4s-5.8-14.71-9.52-17.46a8.388 8.388 0 0 0-10 13.47z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M539.73 687.31s13.54-2.69 17.14-6.27 19.85-9.85 21.66-5.37 24.35 19.7 9 22.39-36.09 3.58-40.6 1.79-7.2-12.54-7.2-12.54z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M587.55 696.39c-15.34 2.69-36.09 3.59-40.6 1.8-3.43-1.37-5.82-7.92-6.77-11l-.45.09s2.71 10.75 7.22 12.54 25.26.9 40.6-1.79c4.42-.78 5.69-2.6 5.21-4.9-.38 1.53-1.92 2.69-5.21 3.26z",
    opacity: 0.2
  }), React.createElement("g", {
    opacity: 0.75
  }, React.createElement("path", {
    d: "M680.09 428.89a10.85 10.85 0 0 1-.59-1.52c-.31-1.21.07-2.47.09-3.72a13.14 13.14 0 0 0-.29-2.57c-.59-3.23-1.17-6.47-1.76-9.71-.27-1.49-.54-3-.67-4.49s-.11-3.1-.14-4.65c-.07-5-1-10-1.15-15.05-.11-2.61-.31-5.22-.52-7.83-.37-4.48-.76-9-1.55-13.38-.62-3.51-2.38-6.79-2.42-10.35 0-1.85 0-3.7-.05-5.55a10.64 10.64 0 0 0-.74-4.66 10.24 10.24 0 0 0-2.74-3.13q-4.72-4.08-9.78-7.75a6 6 0 0 0 3.06-.23 2 2 0 0 0 1.17-2.52 2.52 2.52 0 0 0-1.55-1.12 14.18 14.18 0 0 0-3.72-.6 13.74 13.74 0 0 0 .27-1.45c.66-5.16-1.93-10.22-1.92-15.42 0-5.36 2.72-10.27 4.29-15.39a37.18 37.18 0 0 0-1.1-24.73c-1.69-4.16-4.16-8.07-5-12.48-.65-3.46-.24-7-.83-10.51-1.48-8.83-9.35-15.62-18-18-6.67-1.81-13.46-1.23-20.17 0-5.77 1.07-11-1.29-16.8-.53-2.26.29-4.61 1-6.07 2.78a32.94 32.94 0 0 0-2 3.39c-2.57 4-7.67 5.37-11.91 7.56-6.44 3.34-11.57 9.57-12.53 16.75-.89 6.66 1.73 13.26 2.13 20 .51 8.56-2.6 16.86-5.23 25a19.53 19.53 0 0 0-1.31 7 18.81 18.81 0 0 0 1.08 4.78c.83 2.52 1.77 5 2.84 7.45a24.81 24.81 0 0 1-6.22 1.63c-2.18.25-4.51.16-6.4 1.27a7.48 7.48 0 0 0-2.22 2.12 11.65 11.65 0 0 0-2 8.79 2.73 2.73 0 0 0-1.27 2.34c-.05.93.16 1.85.2 2.78a17.57 17.57 0 0 1-1 5.14 43.59 43.59 0 0 0-1.14 17.46c1.28 9.34 1.53 18.61 1.94 28 .27 6.17-.24 12.41.78 18.51.34 2 1 4.2 2.58 5.48a11.23 11.23 0 0 1 1.16.9c.9.94.93 2.39 1.23 3.66a7.88 7.88 0 0 0 8.12 5.79c-.67 2-1.33 3.85-2 5.77H661c-.06-.24-.12-.48-.17-.72a10.81 10.81 0 0 1-.07-3.06c.86 1 .71 2.47.94 3.78H681a16.64 16.64 0 0 0-.91-7.01z",
    transform: "translate(-169.54 -44.5)",
    fill: "url(#prefix__c)"
  }), React.createElement("path", {
    d: "M428.46 188.27c-2.25.3-4.58 1-6 2.77a31.47 31.47 0 0 0-2 3.37c-2.55 4-7.62 5.33-11.82 7.51-6.4 3.31-11.49 9.51-12.44 16.64-.89 6.62 1.71 13.18 2.11 19.84.5 8.5-2.58 16.75-5.19 24.86a19.48 19.48 0 0 0-1.31 7 18.59 18.59 0 0 0 1.08 4.75c2.4 7.27 5.65 14.35 10.49 20.28s11.38 10.67 18.83 12.42a53.87 53.87 0 0 0 10.38 1.1q8 .3 16 .3a45.82 45.82 0 0 0 8.76-.59c6.11-1.19 11.49-4.64 16.71-8 6-3.9 12.6-8.69 13.51-15.8.65-5.12-1.91-10.15-1.91-15.32s2.7-10.2 4.26-15.28a37 37 0 0 0-1.1-24.62c-1.68-4.14-4.13-8-5-12.41-.65-3.43-.25-7-.83-10.44-1.47-8.77-9.28-15.51-17.86-17.84-6.63-1.79-13.37-1.23-20 0-5.67 1.05-10.94-1.31-16.67-.54z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M430.28 261.76a21.59 21.59 0 0 1-2.69 16.27 26.18 26.18 0 0 1-5.79 6.05 37.05 37.05 0 0 1-11.42 6.31 23 23 0 0 0 8.78 4.27 41.78 41.78 0 0 0 7.49.91 213 213 0 0 0 37.87-1.37c4.2-.53 8.58-1.26 12-3.79a1.7 1.7 0 0 0 .67-.79c.24-.83-.75-1.46-1.57-1.74-4-1.39-8.41-2.18-11.91-4.64-5.36-3.77-7.6-10.68-8.08-17.21s.46-13.12-.18-19.65q-13-.19-26 .76c-1 .07-5.32-.17-5.84.66s1.84 3.24 2.44 4.15a28.83 28.83 0 0 1 4.23 9.81z",
    fill: "#fbbebe"
  }), React.createElement("circle", {
    cx: 442.27,
    cy: 232.38,
    r: 29.57,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 442.27,
    cy: 231.33,
    r: 29.57,
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M483.79 340.2c-2.42 9.9-3.94 20.15-2.92 30.3.68 6.72 3 14 3.16 20.88h-73.32v-11.35-2.11-2.73-8.17c0-4.79 0-9.6-.51-14.37a105.06 105.06 0 0 0-5.86-24.87l-.63-1.76c0-.07 0-.13-.08-.19-.21-.6-.44-1.19-.66-1.79-3.57-9.48-7.65-19.32-5.69-29.18a25.27 25.27 0 0 1 12.18-16.91 13.73 13.73 0 0 1 6.31-1.94c3.81-.06 7.24 2.18 10.42 4.3 1.51 1 3 2 4.59 3a50.62 50.62 0 0 0 11.76 5.62c5.91 1.79 12.6 1.86 18-1.12a21.09 21.09 0 0 0 3-2.06 34.25 34.25 0 0 0 4.94-5.2c1.44 2.8 4.56 4 7.15 5.75a22.36 22.36 0 0 1 7.83 10.45 57.62 57.62 0 0 1 3 12.88 67.07 67.07 0 0 1 .86 13c-.38 6-2.12 11.77-3.53 17.57z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M439.72 391.38h-50.17l2-5.74h-.09a7.81 7.81 0 0 1-8.06-5.76c-.3-1.26-.33-2.69-1.23-3.63a10 10 0 0 0-1.14-.89c-1.62-1.27-2.23-3.42-2.56-5.45-1-6.06-.52-12.25-.78-18.39-.41-9.36-.66-18.58-1.93-27.86a43.35 43.35 0 0 1 1.13-17.34 17.37 17.37 0 0 0 1-5.11c0-.92-.25-1.84-.2-2.76a2.69 2.69 0 0 1 1.26-2.32 11.61 11.61 0 0 1 2-8.74 7.65 7.65 0 0 1 2.21-2.11c1.88-1.1 4.19-1 6.35-1.26 10.1-1.14 18.1-10 28.21-11a38.15 38.15 0 0 1 6.84.16c3.72.31 5.08 5 5.94 8.66.12.48.22 1 .32 1.44 1.9 9 1.55 18.4 1.55 27.65a23.38 23.38 0 0 0 .86 6.28c1.53 5.58 1.69 11.42 2 17.2a389.7 389.7 0 0 0 4.06 40.34 73.94 73.94 0 0 1 .93 7.56 45.8 45.8 0 0 1-.5 9.07z",
    fill: "#f86d70"
  }), React.createElement("path", {
    d: "M429.04 318.22a28.77 28.77 0 0 1 2.92 3.95c.4.66.73 1.62.14 2.12a1.75 1.75 0 0 1-1.08.3l-7 .3a8.15 8.15 0 0 1-3.16-.29 8 8 0 0 1-3.28-2.93l-3.12-4.08a9.23 9.23 0 0 1-2-3.52 3.16 3.16 0 0 1 1.4-3.5 4.65 4.65 0 0 1 3.44.24c2.12.72 4.64 1.2 6.51 2.43a26.88 26.88 0 0 1 5.23 4.98z",
    fill: "#f86d70"
  }), React.createElement("path", {
    d: "M429.04 318.22a28.77 28.77 0 0 1 2.92 3.95c.4.66.73 1.62.14 2.12a1.75 1.75 0 0 1-1.08.3l-7 .3a8.15 8.15 0 0 1-3.16-.29 8 8 0 0 1-3.28-2.93l-3.12-4.08a9.23 9.23 0 0 1-2-3.52 3.16 3.16 0 0 1 1.4-3.5 4.65 4.65 0 0 1 3.44.24c2.12.72 4.64 1.2 6.51 2.43a26.88 26.88 0 0 1 5.23 4.98z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M425.04 318.69a100.14 100.14 0 0 1 3.53-13.54 31.71 31.71 0 0 0 1.77-6.58c.19-1.77 0-3.56.18-5.33.14-1.53.51-3 .74-4.54a22.81 22.81 0 0 0-.55-9.23c-.64-2.39 0-5.3-1.56-7.24-.62-.79-1.45-1.39-2.1-2.16a3 3 0 0 1-.79-2.77 17.46 17.46 0 0 0 6.64.21 4.36 4.36 0 0 0 1.86-.65 1.75 1.75 0 0 0 .78-1.69 2.44 2.44 0 0 0-1.27-1.45 15.57 15.57 0 0 0-13.23-1.48.77.77 0 0 1 .33-.94 2.83 2.83 0 0 1 1-.33 6.9 6.9 0 0 0 4.93-4.28 1.46 1.46 0 0 0 .1-.94c-.26-.73-1.3-.69-2.05-.5l-4.08 1a9.58 9.58 0 0 0-2.28.77 9.38 9.38 0 0 0-2.33 2c-2.14 2.31-4.32 4.69-5.5 7.61-.53 1.32-.84 2.72-1.39 4a6.16 6.16 0 0 1-2.68 3.21 3.47 3.47 0 0 0-1.75 3.68 10.3 10.3 0 0 0 1.86 4 48.84 48.84 0 0 0 5.13 6.67 18.6 18.6 0 0 1 3.5 4.29c.58 1.18.83 2.5 1.34 3.7a8.11 8.11 0 0 1 .65 1.76 4.5 4.5 0 0 1 0 1.32c-.85 6.65-5.78 12.07-7.62 18.51a1.81 1.81 0 0 0 1 2.37c3.58 2.71 8 4.11 12.24 5.46a46.25 46.25 0 0 0 1.6-6.91z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M424.46 318.39a100.14 100.14 0 0 1 3.53-13.54 31.1 31.1 0 0 0 1.77-6.58c.19-1.77 0-3.56.18-5.33.14-1.53.51-3 .74-4.54a22.81 22.81 0 0 0-.55-9.23c-.64-2.39 0-5.3-1.56-7.24-.62-.79-1.45-1.39-2.1-2.16a3 3 0 0 1-.79-2.77 17.46 17.46 0 0 0 6.64.21 4.36 4.36 0 0 0 1.86-.65 1.78 1.78 0 0 0 .79-1.69 2.49 2.49 0 0 0-1.28-1.45 15.57 15.57 0 0 0-13.23-1.48.77.77 0 0 1 .33-.94 2.82 2.82 0 0 1 1-.33 6.9 6.9 0 0 0 4.92-4.28 1.44 1.44 0 0 0 .1-.93c-.26-.74-1.3-.7-2-.51l-4.07 1a9.5 9.5 0 0 0-2.29.77 9.38 9.38 0 0 0-2.33 2c-2.14 2.31-4.32 4.69-5.5 7.61-.53 1.32-.84 2.72-1.39 4a6.16 6.16 0 0 1-2.68 3.21 3.49 3.49 0 0 0-1.75 3.68 10.3 10.3 0 0 0 1.86 4 49.65 49.65 0 0 0 5.13 6.67 18.6 18.6 0 0 1 3.5 4.29c.58 1.18.83 2.5 1.34 3.71a7.84 7.84 0 0 1 .65 1.75 4.5 4.5 0 0 1 0 1.32c-.85 6.65-5.78 12.07-7.62 18.51a1.81 1.81 0 0 0 1 2.37c3.58 2.71 8 4.11 12.24 5.46a46.25 46.25 0 0 0 1.56-6.91z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M427.15 316.72a.73.73 0 0 1 .34.31.75.75 0 0 1 0 .53 44 44 0 0 1-3.86 8.5q-4.77-2.62-9.31-5.61a5 5 0 0 1-1.87-1.76c-4.47-8.63 11.73-3.7 14.7-1.97z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M409.31 320.9c-1.05 1.4-2.26 2.66-3.3 4.07a63.61 63.61 0 0 0-4.55 8.21 56.38 56.38 0 0 1-6.91 10.21c-2.69 3.16-5.91 6.4-6.21 10.54a3.3 3.3 0 0 1-.37 1.71c-.3.44-.83.66-1.22 1s-.63 1-.23 1.41c-1.54.16-2.18 2-2.48 3.53l-.68 3.5a13.81 13.81 0 0 0-.33 2.79 11.56 11.56 0 0 0 .91 3.68 59.56 59.56 0 0 0 6.32 12.2c1.23 1.82 2.65 3.65 4.67 4.52a12.87 12.87 0 0 0 6 .56c2.85-.18 6.16-.63 7.58-3.11.9-1.57.76-3.6 1.74-5.12a17.48 17.48 0 0 1 1.88-2.07 13.37 13.37 0 0 0 2.31-4.56 170.5 170.5 0 0 0 6.24-22.75 36.72 36.72 0 0 1 2.05-7.63 42.73 42.73 0 0 1 3.8-6.27c2.53-3.83 2.91-7.15 4.66-11.39-3.86-.9-5.64-3.46-8.93-5.63-3.1-2.05-7.69-6.41-11-8-1.09 2.73-.18 6.2-1.95 8.6z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M406.95 318.8c-1 1.4-2.26 2.67-3.29 4.08a62.32 62.32 0 0 0-4.55 8.2 56.11 56.11 0 0 1-6.91 10.22c-2.7 3.16-5.91 6.39-6.21 10.54a3.35 3.35 0 0 1-.37 1.7 7.22 7.22 0 0 1-1.23 1c-.39.36-.62 1-.23 1.4-1.54.17-2.18 2-2.47 3.54l-.68 3.5a12.5 12.5 0 0 0-.33 2.78 11.36 11.36 0 0 0 .91 3.69 59.78 59.78 0 0 0 6.31 12.2c1.23 1.82 2.66 3.65 4.68 4.52a12.87 12.87 0 0 0 6 .56c2.84-.18 6.16-.64 7.57-3.11.9-1.58.76-3.6 1.74-5.13a20.31 20.31 0 0 1 1.88-2.06 13.39 13.39 0 0 0 2.32-4.56 170.87 170.87 0 0 0 6.23-22.75 37 37 0 0 1 2-7.64 43.52 43.52 0 0 1 3.8-6.26c2.54-3.83 2.39-6.1 4.14-10.35-3.86-.89-5.12-4.5-8.41-6.67-3.1-2.05-7.68-6.41-11-8-1.03 2.74-.12 6.22-1.9 8.6z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M408.26 319.85c-1 1.4-2.26 2.67-3.29 4.07a61.93 61.93 0 0 0-4.55 8.21 55.69 55.69 0 0 1-6.91 10.21c-2.7 3.17-5.91 6.4-6.21 10.54a3.38 3.38 0 0 1-.37 1.71 7.72 7.72 0 0 1-1.23 1c-.39.36-.62 1-.23 1.4-1.54.16-2.18 2-2.47 3.54l-.68 3.5a12.43 12.43 0 0 0-.33 2.78 11.6 11.6 0 0 0 .9 3.69 60 60 0 0 0 6.32 12.19c1.23 1.83 2.66 3.66 4.68 4.53a13 13 0 0 0 6 .56c2.84-.18 6.16-.64 7.57-3.11.9-1.58.76-3.61 1.74-5.13a20.42 20.42 0 0 1 1.88-2.07 13.43 13.43 0 0 0 2.32-4.55 170.6 170.6 0 0 0 6.23-22.76 36.89 36.89 0 0 1 2-7.63 43.52 43.52 0 0 1 3.8-6.26 71.46 71.46 0 0 0 6.45-12.16 33.24 33.24 0 0 1-10.72-4.87c-3.1-2-7.68-6.41-11-8-1.03 2.74-.13 6.26-1.9 8.61z",
    fill: "#f86d70"
  }), React.createElement("circle", {
    cx: 418.19,
    cy: 322.93,
    r: 2.09,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 411.65,
    cy: 333.14,
    r: 2.09,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 404.85,
    cy: 343.61,
    r: 2.09,
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M511.37 391.38h-19.14c-.23-1.3-.08-2.77-.93-3.77a11.12 11.12 0 0 0 .07 3.05c.05.24.11.48.17.72H467.2a38.82 38.82 0 0 1 .87-9.13 84.56 84.56 0 0 0 1.39-13.28c.12-5.51-.29-11-.32-16.51a120 120 0 0 1 1.05-16.3c.66-5 1.64-10 .83-15-.91-5.53-1.69-11.13-2.39-16.69a18.63 18.63 0 0 0-.7-3.63 23.74 23.74 0 0 0-1-2.43 37.41 37.41 0 0 1-3.24-12.73c-.14-1.66-2.49-3.16-2.46-4.84 3.2-.65 8.91-1.45 12-.34s5.37 3.84 8.47 4.87 6.38.28 9.39 1.29a2.5 2.5 0 0 1 1.55 1.1 2 2 0 0 1-1.17 2.51 5.85 5.85 0 0 1-3 .23q5 3.65 9.7 7.7a10.22 10.22 0 0 1 2.72 3.11 10.65 10.65 0 0 1 .74 4.63c0 1.84 0 3.67.05 5.51 0 3.54 1.78 6.8 2.4 10.28.78 4.4 1.17 8.85 1.53 13.3.21 2.59.41 5.18.52 7.78.2 5 1.07 10 1.15 14.95 0 1.54 0 3.09.14 4.62a45 45 0 0 0 .66 4.47c.58 3.21 1.16 6.43 1.75 9.64a13 13 0 0 1 .28 2.55 14.38 14.38 0 0 0-.09 3.7 10.73 10.73 0 0 0 .59 1.51 16.75 16.75 0 0 1 .76 7.13z",
    fill: "#f86d70"
  }), React.createElement("ellipse", {
    cx: 443.45,
    cy: 208.17,
    rx: 28.27,
    ry: 10.99,
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M458.65 219.27c-8.88-3.49-12.36 4.12-12.36 4.12-3.42 9.12 3 14.46 6.86 16.75a9.51 9.51 0 0 0 4.85 1.33 9.3 9.3 0 0 0 3.61-.71 15.55 15.55 0 0 0 9.73-12c1.58-12.34-12.69-9.49-12.69-9.49zm9.26 9.7a13 13 0 0 1-7.91 10 7.56 7.56 0 0 1-6.87-.52c-3.15-1.9-8.36-6.36-5.58-13.95 0 0 2.83-6.34 10-3.43.05-.02 11.65-2.4 10.36 7.9z",
    fill: "#f86d70"
  }), React.createElement("path", {
    d: "M457.6 221.05s11.6-2.38 10.31 7.92a13 13 0 0 1-7.91 10 7.55 7.55 0 0 1-2.93.59 7.52 7.52 0 0 1-3.94-1.11c-3.15-1.9-8.36-6.36-5.58-13.95 0 0 2.83-6.36 10.05-3.45z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M627.14 265.55s11.6-2.38 10.31 7.92a13 13 0 0 1-7.91 10 7.55 7.55 0 0 1-2.93.59 7.52 7.52 0 0 1-3.94-1.11c-3.15-1.9-8.36-6.36-5.58-13.95 0 0 2.83-6.36 10.05-3.45z",
    transform: "translate(-169.54 -44.5)",
    opacity: 0.1,
    fill: "url(#prefix__b)"
  }), React.createElement("path", {
    d: "M412.58 228.78a15.55 15.55 0 0 0 9.73 12 9.3 9.3 0 0 0 3.61.71 9.51 9.51 0 0 0 4.85-1.33c3.88-2.29 10.28-7.63 6.86-16.75 0 0-3.48-7.61-12.36-4.12 0-.02-14.27-2.87-12.69 9.49zm13.74-7.73c7.22-2.91 10 3.43 10 3.43 2.78 7.59-2.43 12-5.58 13.95a7.56 7.56 0 0 1-6.87.52 13 13 0 0 1-7.91-10c-1.24-10.28 10.36-7.9 10.36-7.9z",
    fill: "#f86d70"
  }), React.createElement("path", {
    d: "M426.32 221.05s-11.6-2.38-10.31 7.92a13 13 0 0 0 7.91 10 7.55 7.55 0 0 0 2.93.59 7.52 7.52 0 0 0 3.94-1.11c3.15-1.9 8.36-6.36 5.58-13.95 0 0-2.83-6.36-10.05-3.45z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M595.86 265.55s-11.6-2.38-10.31 7.92a13 13 0 0 0 7.91 10 7.55 7.55 0 0 0 2.93.59 7.52 7.52 0 0 0 3.94-1.11c3.15-1.9 8.36-6.36 5.58-13.95 0 0-2.83-6.36-10.05-3.45z",
    transform: "translate(-169.54 -44.5)",
    opacity: 0.1,
    fill: "url(#prefix__d)"
  })));
};

UndrawMakingArt.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawMakingArt;